import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

// Import your images
import manaliImg from "../assets/manali.png";
import shimlaImg from "../assets/shimla.png";
import dharamshalaImg from "../assets/dharamshala.png";
import dalhousieImg from "../assets/dalhousie.png";
import spitiImg from "../assets/spiti.png";
import PangiImg from "../assets/pangi-7.png";

const images = [
  { src: manaliImg, title: "Manali", desc: "Snow-capped peaks & adventure hub." },
  { src: shimlaImg, title: "Shimla", desc: "Colonial charm & serene beauty." },
  { src: dharamshalaImg, title: "Dharamshala", desc: "Spiritual and peaceful hill town." },
  { src: dalhousieImg, title: "Dalhousie", desc: "Scenic views and historic charm." },
  { src: spitiImg, title: "Spiti Valley", desc: "High-altitude desert landscapes." },
  { src: PangiImg, title: "Pangi Valley", desc: "Rugged terrain & vibrant culture." },
];

const AnimatedImageViewer = () => {
  const [current, setCurrent] = useState(0);

  // Auto-advance every 4 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        maxWidth: "900px",
        height: "500px", // FIXED: Parent needs height because children are absolute
        margin: "50px auto",
        overflow: "hidden",
        borderRadius: "15px",
        backgroundColor: "#222", // Background color so it's visible while loading
      }}
    >
      <AnimatePresence mode="wait"> 
        {images.map((img, index) =>
          index === current ? (
            <motion.div
              key={img.src}
              initial={{ opacity: 0, scale: 0.9, x: 50 }}
              animate={{ opacity: 1, scale: 1, x: 0 }}
              exit={{ opacity: 0, scale: 1.1, x: -50 }}
              transition={{ duration: 0.8, ease: "easeInOut" }}
              style={{ 
                position: "absolute", 
                width: "100%", 
                height: "100%",
                top: 0,
                left: 0 
              }}
            >
              <img
                src={img.src}
                alt={img.title}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.4 }}
                style={{
                  position: "absolute",
                  bottom: "30px",
                  left: "30px",
                  right: "30px", // Added right to prevent text overflow
                  color: "#fff",
                  backgroundColor: "rgba(0,0,0,0.6)",
                  padding: "20px",
                  borderRadius: "10px",
                  backdropFilter: "blur(5px)", // Added a nice glass effect
                  zIndex: 5
                }}
              >
                <h2 style={{ margin: "0 0 5px 0" }}>{img.title}</h2>
                <p style={{ margin: 0 }}>{img.desc}</p>
              </motion.div>
            </motion.div>
          ) : null
        )}
      </AnimatePresence>

      {/* Navigation buttons */}
      <button
        onClick={() => setCurrent((prev) => (prev - 1 + images.length) % images.length)}
        style={navButtonStyle("left")}
      >
        &#10094;
      </button>
      <button
        onClick={() => setCurrent((prev) => (prev + 1) % images.length)}
        style={navButtonStyle("right")}
      >
        &#10095;
      </button>
    </div>
  );
};

// Navigation button styles
const navButtonStyle = (position) => ({
  position: "absolute",
  top: "50%",
  [position]: "15px",
  transform: "translateY(-50%)",
  background: "rgba(255,255,255,0.2)",
  color: "#fff",
  border: "1px solid rgba(255,255,255,0.3)",
  fontSize: "24px",
  width: "50px",
  height: "50px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "50%",
  cursor: "pointer",
  zIndex: 10,
  transition: "background 0.3s",
  outline: "none",
});

export default AnimatedImageViewer;